module.exports = __webpack_public_path__ + "img/close.3a7808a6.png";